// extracted by mini-css-extract-plugin
export default {"title":"AccountLayout_title__6ZjAH","fullWidth":"AccountLayout_fullWidth__Ucgcw"};